module.exports = ".copy-right {\n  font-size: 12px;\n}\n"